// extracted by mini-css-extract-plugin
module.exports = {"footer":"_1Etq7Y1Xml4y0bf3ANfcTE"};